import { lazy, Suspense, useEffect, type ReactNode } from "react";
import Home from "../app/page";
import DownloadsPage from "../app/downloads/page";

const AuthPage = lazy(() => import("./AuthPage").then((module) => ({ default: module.AuthPage })));
const AuthCallbackPage = lazy(() => import("./AuthCallbackPage").then((module) => ({ default: module.AuthCallbackPage })));
const DashboardPage = lazy(() => import("./DashboardPage").then((module) => ({ default: module.DashboardPage })));
const VideoEditorDashboard = lazy(() => import("./VideoEditorDashboard").then((module) => ({ default: module.VideoEditorDashboard })));

function securePage(content: ReactNode) {
  return <Suspense fallback={<main className="account-page"><div className="shell account-loading">Loading secure access…</div></main>}>{content}</Suspense>;
}

export function App() {
  const pathname = window.location.pathname.replace(/\/+$/, "") || "/";
  let title = "Broadcast everywhere. Prove what it earned. · GeoStream";
  let content: ReactNode = <Home />;
  if (pathname === "/downloads") {
    title = "Downloads · GeoStream";
    content = <DownloadsPage />;
  } else if (pathname === "/login" || pathname === "/account") {
    title = "Sign in · GeoStream";
    content = securePage(<AuthPage mode="login" />);
  } else if (pathname === "/signup") {
    title = "Create account · GeoStream";
    content = securePage(<AuthPage mode="signup" />);
  } else if (pathname === "/auth/callback") {
    title = "Completing sign in · GeoStream";
    content = securePage(<AuthCallbackPage />);
  } else if (pathname === "/dashboard") {
    title = "Dashboard · GeoStream";
    content = securePage(<DashboardPage />);
  } else if (pathname === "/video-editor" || pathname === "/video-editor-dashboard") {
    title = "Video editor · GeoStream";
    content = securePage(<VideoEditorDashboard />);
  } else if (pathname !== "/") {
    title = "Not found · GeoStream";
    content = <main className="not-found"><div className="shell"><p className="eyebrow">404</p><h1>That page is not available.</h1><a className="button button-primary" href="/">Return home</a></div></main>;
  }
  useEffect(() => { document.title = title; }, [title]);
  return content;
}
